import type { ReactNode } from "react";
import { useIntl } from "react-intl";

import { Divider } from "@/components/Divider/Divider";

type Props = {
  title: ReactNode;
  totalPrice?: ReactNode;
  footer?: ReactNode;
  children: ReactNode;
};

export const PaymentDetails = ({
  title,
  totalPrice,
  footer,
  children,
}: Props) => {
  const intl = useIntl();

  return (
    <div className="section-card flex flex-col gap-4">
      {title ? (
        <div className="text-lg font-medium text-text-primary">{title}</div>
      ) : null}

      <dl className="grid grid-cols-2 gap-3 text-sm">{children}</dl>

      {totalPrice != null ? (
        <>
          <Divider color="neutral-soft" />
          <div className="flex items-center justify-between gap-4 text-text-primary">
            <div>
              <div className="text-sm font-semibold">
                {intl.formatMessage({
                  defaultMessage: "Total price",
                  description: "Label for the total booking price",
                })}
              </div>
              <div className="text-xs text-text-placeholder">
                {intl.formatMessage({
                  defaultMessage: "Include taxes and charges",
                  description: "Total booking price description",
                })}
              </div>
            </div>

            <div className="text-lg font-semibold">{totalPrice}</div>
          </div>{" "}
        </>
      ) : null}

      {footer ? <div>{footer}</div> : null}
    </div>
  );
};
